import React, { useContext, useEffect } from 'react'
import { AppSettings } from '../../config/app-settings'
import Loader from '../pages/loader'
import { useParams } from 'react-router-dom'
import { useGetCampaignByIdQuery } from '../../redux/apis/campaignsManagement/campaigns/cMCampaignsApiSlice'
import DetailsHeader from '../../components/campaigns/details/DetailsHeader'
import AnalyticsBox from '../../components/Dashboard/AnalyticsBox'
import ServicesData from '../../components/Dashboard/ServicesData'
import MonthlyDetectedRemoved from '../../components/Dashboard/MonthlyDetectedRemoved'
import TopRemovals from '../../components/Dashboard/TopRemovals'

const CampaignDetails = React.memo(() => {
  const { id } = useParams()
  const context = useContext(AppSettings)

  const {
    data: campaign,
    isLoading,
    isError,
    error
  } = useGetCampaignByIdQuery({
    id,
    expand: ['country'].join(',')
  })

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  if (isLoading) return <Loader />
  if (isError)
    return (
      <div className='text-red-500'>
        Error: {error?.message || 'Something went wrong'}
      </div>
    )

  return (
    <div className='w-full flex flex-col p-4'>
      <div className='flex flex-col gap-8'>
        <DetailsHeader data={campaign?.data} />
        <AnalyticsBox campaignId={id} />
        <ServicesData campaignId={id} />
        <div
          className='flex justify-between wrapContainer gap-4'
          style={{ flexWrap: 'wrap' }}
        >
          <MonthlyDetectedRemoved campaignId={id} />
          <TopRemovals campaignId={id} />
        </div>
      </div>
    </div>
  )
})

export default CampaignDetails
